import React from 'react';
import classNames from 'classnames';

import './ProductsContainer.module.scss';

const ProductsContainer = ({ isMobile, children }) => (
  <section styleName={classNames('container', { mobile: isMobile })}>
    {React.Children.map(children, (child) => (
      <div styleName="item">{child}</div>
    ))}
  </section>
);

export default ProductsContainer;
